<div class="dashboard-tableau">
    @if (placeholderPath(); as path) {
    <p class="dashboard-tableau__placeholder">
        {{ 'Dashboard.TableauPlaceholder' | translate: { path: path } }}
    </p>
    } @else if (embed(); as view) {
    <tableau-viz
        [id]="vizId"
        [src]="view.vizUrl"
        [token]="view.token"
        [attr.height]="embedHeight()"
        (firstinteractive)="onFirstInteractive($event)"
        width="100%"
        device="desktop"
    />
    } @else if (showError()) {
    <!-- Two-level keys: the app's missing-translation handler only resolves two. -->
    <p class="dashboard-tableau__message">{{ 'Dashboard.TableauError' | translate }}</p>
    } @else if (showLoading()) {
    <p class="dashboard-tableau__message">{{ 'Dashboard.TableauLoading' | translate }}</p>
    }
</div>
